import { Grid, makeStyles } from '@material-ui/core';
import { Formik } from 'formik';
import i18n from 'i18n';
import { registerNewInstanceRequest } from 'modules/environments/actions';
import { modalClose } from 'modules/modal/actions';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import { applyI18n } from 'utils/helpers';
import Button from 'components/Button';
import formStyles from '../Form/styles';
import screenFields from './formFields';
import validationSchema from './schema';

const useStyles = makeStyles(formStyles);

interface Props {
  onCancel: () => void;
  environmentUuid: string;
  registerNewInstanceRequest: ({ environmentUuid, values }) => void;
  modalClose: () => void;
}

function FormRegisterInstance({
  onCancel,
  registerNewInstanceRequest,
  modalClose,
  environmentUuid,
}: Props) {
  const classes = useStyles();

  const onSubmit = values => {
    registerNewInstanceRequest({ environmentUuid, values });
    modalClose();
  };

  return (
    <Grid item container>
      <Formik
        initialValues={{}}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2}>
            <GenericForm
              fields={values}
              screenFields={applyI18n(screenFields, i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />

            <Grid
              container
              justify="flex-end"
              className={classes.buttons}
              style={{ margin: '24px 0 0' }}
            >
              <Button
                id="submit-button"
                submitButton
                onClick={submitForm}
                disabled={false}
              >
                {i18n.t('REGISTER_KEY')}
              </Button>
              <Button id="cancel-button" variant="outlined" onClick={onCancel}>
                {i18n.t('CANCEL_KEY')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
}

const mapStateToProps = ({
  environments: { isLoading },
}: ApplicationState) => ({
  isLoading,
});

export default connect(mapStateToProps, {
  registerNewInstanceRequest,
  modalClose,
})(FormRegisterInstance);
